import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Anda memiliki tagihan ")
const _hoisted_2 = { class: "font-semibold text-14px" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" dengan STT ")
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-20px font-bold text-gray-lp-300 mx-auto" }, " Pilih Metode Pembayaran ", -1)
const _hoisted_7 = {
  key: 0,
  class: "pt-5 grid gap-4 grid-cols-4 w-full"
}
const _hoisted_8 = {
  key: 1,
  class: "pt-5 grid gap-4 grid-cols-4 w-full"
}
const _hoisted_9 = { class: "mt-6 text-14px text-gray-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogPaymentLayoutHeader = _resolveComponent("DialogPaymentLayoutHeader")!
  const _component_DialogPaymentLayoutImage = _resolveComponent("DialogPaymentLayoutImage")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DialogPaymentLayout = _resolveComponent("DialogPaymentLayout")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_component_DialogPaymentLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_DialogPaymentLayoutHeader, { textHeader: _ctx.textHeader }, {
        "sub-header": _withCtx(() => [
          _hoisted_1,
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.billAmount), 1),
          (_ctx.billType === 'booking')
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.sttNumber), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["textHeader"]),
      _createVNode(_component_DialogPaymentLayoutImage, { image: "success-booking-illustration" }),
      _hoisted_6,
      (!_ctx.isLoadPaymentMethods)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (paymentMethod) => {
              return (_openBlock(), _createBlock("div", {
                key: paymentMethod.name,
                class: "border border-gray-lp-1300 rounded-lg flex justify-center",
                style: [_ctx.stylePayment(paymentMethod).style, {"height":"56px"}],
                onClick: ($event: any) => (_ctx.payWithQr(paymentMethod))
              }, [
                _createVNode("img", {
                  alt: "payment-logo",
                  class: "self-center",
                  src: 
            require(`@/app/ui/assets/svg/payment/${paymentMethod.logo}-${
              _ctx.stylePayment(paymentMethod).status
            }.svg`)
          
                }, null, 8, ["src"])
              ], 12, ["onClick"]))
            }), 128)),
            _createVNode(_component_button_fill, {
              onClick: _ctx.payWithCash,
              title: "Tunai",
              custom: "w-32 text-16px bg-green-lp-400 border-green-lp-100",
              style: {"height":"56px"},
              class: "mr-4",
              iconLeft: "cash_white"
            }, null, 8, ["onClick"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_8, [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(8, (index) => {
              return _createVNode(_component_Skeleton, {
                key: index,
                height: "56px",
                width: "8rem"
              })
            }), 64))
          ])),
      _withDirectives(_createVNode("div", _hoisted_9, null, 512), [
        [_directive_sanitize_html, _ctx.captionPaymentAmountExceed]
      ])
    ]),
    _: 1
  }))
}